// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2AJbe","buttons":"RemoveExpirationActionButtons_buttons__2HQZq"};